import React from 'react';
import Layout from '../components/site/Layout';
import { PageHero, CtaBanner } from '../components/site/PageParts';
import { Industries } from '../components/home/Sections';
import clients from '../components/site/clients';
import useLang from '../i18n/useLang';

export default function Customers() {
  const { t, isHe } = useLang();

  return (
    <Layout title={t('header.Costumers')}>
      <PageHero title={t('pages.customers.title')} lead={t('Clients.paragraph')} />

      <section className="wrap py-20 sm:py-24" aria-label={t('home.logos.title')}>
        {/* Flex rather than grid, so a short last row stays centred whatever the number of logos. */}
        <ul className="flex flex-wrap justify-center gap-4">
          {clients.map((c) => (
            <li
              key={c.name}
              className="group flex aspect-[4/3] w-[calc(50%-0.5rem)] flex-col items-center justify-center gap-4 rounded-3xl bg-white p-6 ring-1 ring-fog-200 transition-shadow duration-300 hover:shadow-card sm:w-[calc(33.333%-0.667rem)] lg:w-[calc(25%-0.75rem)]"
            >
              <img
                src={c.logo}
                alt=""
                loading="lazy"
                className="max-h-16 w-auto max-w-[70%] object-contain opacity-80 mix-blend-multiply grayscale transition-[filter,opacity] duration-300 group-hover:opacity-100 group-hover:grayscale-0"
              />
              <span className="text-sm font-medium text-ink-500">{isHe ? c.nameHe : c.name}</span>
            </li>
          ))}
        </ul>
      </section>

      <div className="bg-fog-50">
        <Industries />
      </div>

      <CtaBanner />
    </Layout>
  );
}
